import styled from "styled-components";

export const StyledPromoLabel = styled.label`
  font-size: 10px;
  border-radius: 10px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};
`;
